import { useEliteOnboardingAdvisoryStatus } from '../../hooks/useEliteOnboardingAdvisoryStatus'
import { NewEliteLandingAnalyticsScreen } from '../../analytics/newEliteLandingAnalytics'
import NewEliteDashboardPage from '../NewEliteDashboardPage'
import { buildFamilyOnboardingViewProps } from './familyOnboardingViewProps'

export default function NewEliteFamilyDashboardPage() {
  const { data } = useEliteOnboardingAdvisoryStatus('NEW_ELITE_DASHBOARD_ONBOARDING_ADVISORY_STATUS')
  const familyConfig = buildFamilyOnboardingViewProps(data)

  return (
    <NewEliteDashboardPage
      familyConfig={familyConfig}
      analyticsScreen={NewEliteLandingAnalyticsScreen.FamilyDashboard}
    />
  )
}
